import {KTIcon} from '../../../../_metronic/helpers'
const EmailModalHeader = ({
  onClose
}) => {  
  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Download Promo Codes</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={onClose}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
    </div>
  )
}

export {EmailModalHeader}
